<template>
  <div v-if="label" class="promotion-label" >
    <span :class="labelClass">{{ label }}</span>
  </div>
</template>

<script>


export default {
  props: {
    promotion: {
      type: Array,
      required: true
    }
  },
  computed: {
    label() {
      if (this.promotion[0].searchKey.toLowerCase() === 'campaign') {
        return this.promotion[0].name
      } else if (this.promotion[0].searchKey.toLowerCase() === 'new') {
        return this.promotion[0].name
      } else if (this.promotion[0].searchKey.toLowerCase() === 'special') {
        return this.promotion[0].name
      }
      return null
    },
    labelClass() {
      return this.promotion[0].searchKey ? this.promotion[0].searchKey.toLowerCase() : ''
    }
  }
}
</script>

<style lang="scss" scoped>

.promotion-label {  
   display: flex;
   align-items: center;
   margin: 0 0 24px;
   
    // flat tab on top of the product frame (positioned by product.vue)
    span {
      color: white;
      font-weight: bold;
      font-size: 12px;
      line-height: 1.4;
      letter-spacing: 0.5px;
      padding: 2px 12px;
      border-radius: 6px 6px 0 0;
      white-space: nowrap;

      &.campaign {
        background-color: #ffa500;
      }

      &.new {
        background-color: #2196F3;
      }

      &.special {
        background-color: #35c1b6;
      }
    }
}
</style>